// Port of api/fuel/app/classes/filter/core/search/query.php
// The SQL query builder for the filter engine.
// Accumulates clauses and generates SQLite-compatible SQL.

import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'

function whereBuilder(field, value, type) {
	// Port of Stream\Model\Traits\Find\Complex\Where::find_complex_where_builder
	type = (type || '=').toLowerCase()

	if (field.indexOf('.') === -1) field = 'model.' + field

	if (Array.isArray(value) && ['in', 'not in', 'contains one', 'text in', 'text not in'].indexOf(type) === -1) {
		type = 'in'
	}

	field = field.replace(/link\.([a-zA-Z0-9_]+)\.meta\.([a-zA-Z0-9_]+)/g, 'link_$1_meta_$2.meta_value')
	field = field.replace(/link\.([a-zA-Z0-9_]+)\.([a-zA-Z0-9_]+)/g, 'link_$1.$2')
	field = field.replace(/meta\.([a-zA-Z0-9_]+)/g, 'meta_$1.meta_value')
	field = field.replace(/relation\.([a-zA-Z0-9_]+)\.([a-zA-Z0-9_]+)/g, 'relation_$1.$2')

	if (value === '{{time}}') {
		value = Math.floor(Date.now() / 1000)
	}

	function escapeDoubleQuoted(val) {
		return String(val).replace(/\\/g, '\\\\').replace(/"/g, '\\"')
	}

	var sql = ''
	var isSchema

	switch (type) {
		case '>':
		case '>=':
		case '<':
		case '<=':
		case '<>':
		case '=':
			isSchema = (typeof value === 'string' && value.indexOf('model.') === 0)
			if (isSchema) {
				sql = field + ' ' + type + ' ' + value
			} else if (typeof value === 'number' && isFinite(value)) {
				sql = field + ' ' + type + ' ' + value
			} else {
				sql = field + ' ' + type + ' "' + escapeDoubleQuoted(value) + '"'
			}
			break

		case '=lower':
			sql = 'LOWER(' + field + ') = "' + escapeDoubleQuoted(String(value).toLowerCase()) + '"'
			break

		case 'not contains':
			sql = field + ' NOT LIKE \'%"' + String(value).replace(/'/g, "''") + '"%\''
			break

		case 'contains':
			sql = field + ' LIKE \'%"' + String(value).replace(/'/g, "''") + '"%\''
			break

		case 'contains one':
			var parts = []
			value = Array.isArray(value) ? value : []
			if (!value.length) value.push(0)
			for (var i = 0; i < value.length; i++) {
				parts.push(field + ' LIKE \'%"' + String(value[i]).replace(/'/g, "''") + '"%\'')
			}
			sql = '(' + parts.join(' OR ') + ')'
			break

		case 'in':
			var finalIn = []
			if (Array.isArray(value)) {
				for (var j = 0; j < value.length; j++) finalIn.push("'" + value[j] + "'")
			} else {
				finalIn.push("'0'")
			}
			if (finalIn.length > 1) {
				sql = field + ' IN (' + finalIn.join(',') + ')'
			} else if (finalIn.length === 1) {
				sql = field + ' = ' + finalIn[0]
			}
			break

		case 'text in':
			var finalTextIn = []
			if (Array.isArray(value)) {
				for (var k = 0; k < value.length; k++) {
					var lv = String(value[k]).toLowerCase().replace(/'/g, "''")
					finalTextIn.push("'" + lv + "'")
					finalTextIn.push("'" + lv.replace(/-/g, ' ') + "'")
				}
			}
			if (finalTextIn.length) sql = 'LOWER(' + field + ') IN (' + finalTextIn.join(',') + ')'
			break

		case 'text not in':
			var finalTextNotIn = []
			if (Array.isArray(value)) {
				for (var m = 0; m < value.length; m++) {
					var lvn = String(value[m]).toLowerCase().replace(/'/g, "''")
					finalTextNotIn.push("'" + lvn + "'")
					finalTextNotIn.push("'" + lvn.replace(/-/g, ' ') + "'")
				}
			}
			if (finalTextNotIn.length) sql = 'LOWER(' + field + ') NOT IN (' + finalTextNotIn.join(',') + ')'
			break

		case 'not in':
			var finalNotIn = []
			if (Array.isArray(value)) {
				for (var n = 0; n < value.length; n++) finalNotIn.push("'" + value[n] + "'")
			}
			if (finalNotIn.length > 1) {
				sql = field + ' NOT IN (' + finalNotIn.join(',') + ')'
			} else if (finalNotIn.length === 1) {
				sql = field + ' <> ' + finalNotIn[0]
			}
			break

		case 'like':
			sql = 'LOWER(' + field + ') LIKE "' + escapeDoubleQuoted(value) + '"'
			break

		case 'not like':
			sql = 'LOWER(' + field + ') NOT LIKE "' + escapeDoubleQuoted(value) + '"'
			break
	}

	sql = sql.replace(/model\.!/g, '')

	return sql
}

function Query() {
	this._rename = {}
	this._from = []
	this._join = []
	this._concat = []
	this._source = []
	this._leftjoin = []
	this._leftjoin_force = []
	this._exist = []
	this._select = []
	this._where = []
	this._whitelist = []
	this._having = []
	this._order = []
	this._group = []
	this._orderless = false
}

Query.forge = function() {
	return new Query()
}

Query.prototype.orderless = function() {
	this._orderless = true
}

Query.prototype.rename = function(from, to) {
	this._rename[from] = to
}

Query.prototype.concat = function(field, name) {
	this._concat.push([field, name])
}

Query.prototype.from = function(table, name) {
	name = this._checkRename(name)
	this._from = [table, name]
	return this
}

Query.prototype.existed = function(name) {
	for (var i = 0; i < this._exist.length; i++) {
		if (name === this._exist[i][1]) return true
	}
	return false
}

Query.prototype.sourced = function(name) {
	for (var i = 0; i < this._source.length; i++) {
		if (name === this._source[i][1]) return true
	}
	return false
}

Query.prototype.source = function(table, name) {
	name = this._checkRename(name)
	this._source.push([table, name])
	return this
}

Query.prototype.exist = function(table, name, not) {
	name = this._checkRename(name)
	this._exist.push([table, name, not || false])
	return this
}

Query.prototype.notexist = function(table, name) {
	name = this._checkRename(name)
	this.exist(table, name, true)
	return this
}

Query.prototype.leftjoin = function(name, force) {
	this._leftjoin.push(name)
	if (force) this._leftjoin_force.push(name)
}

Query.prototype.join = function(table, name, type, field, priority) {
	type = type || 'JOIN'
	field = field || 'game_id'
	priority = priority || 10

	if (table === 'game' && priority === 10) priority = 9

	name = this._checkRename(name)

	var exists = false
	for (var i = 0; i < this._join.length; i++) {
		if (name === this._join[i][1]) exists = true
	}

	if (!exists) {
		if (this._leftjoin.indexOf(name) !== -1) type = 'LEFT JOIN'
		this._join.push([table, name, type, field, priority])
	}

	return this
}

Query.prototype.select = function(field, name) {
	field = this._checkRename(field)
	this._select.push([field, name])
	return this
}

Query.prototype.where = function(field, comparison, value) {
	var fl = field.toLowerCase()
	if (
		fl.indexOf('min(') !== -1 ||
		fl.indexOf('max(') !== -1 ||
		fl.indexOf('sum(') !== -1 ||
		fl.indexOf('avg(') !== -1 ||
		fl.indexOf('count(') !== -1 ||
		fl.indexOf('uc_') !== -1
	) {
		return this.having(field, comparison, value)
	}

	field = this._checkRename(field)
	this._where.push([field, comparison, value])
	return this
}

Query.prototype.whitelist = function(field, comparison, value) {
	field = this._checkRename(field)
	this._whitelist.push([field, comparison, value])
	return this
}

Query.prototype.whereGroup = function(andor, groups) {
	var str = JSON.stringify(groups)
	if (str.toLowerCase().indexOf('min(') !== -1 || str.toLowerCase().indexOf('max(') !== -1) {
		return this.havingGroup(andor, groups)
	}
	groups = this._checkRename(groups)
	this._where.push([andor, groups])
	return this
}

Query.prototype.having = function(field, comparison, value) {
	field = this._checkRename(field)
	this._having.push([field, comparison, value])
	return this
}

Query.prototype.havingGroup = function(andor, where) {
	where = this._checkRename(where)
	this._having.push([andor, where])
	return this
}

Query.prototype.order = function(field, direction, priority) {
	field = this._checkRename(field)
	this._order.push([field, direction ? 'desc' : 'asc', priority || 0])
	return this
}

Query.prototype.group = function(field) {
	field = this._checkRename(field)
	this._group.push(field)
	return this
}

// Run the query: prepare, build SQL, execute, parse results
Query.prototype.run = function(config, filter, data) {
	this.prepare(config, filter, data)
	var sql = this.build(config, filter, data)

	// Use queryFast for the row materialization. For collection on a
	// behemoth user this query returns 6000+ rows; the per-row
	// stmt.getAsObject() of DB.query is the dominant cost.
	var rawResults
	try {
		rawResults = DB.queryFast(sql)
	} catch (error) {
		throw new Error((error && error.message ? error.message : String(error)) + '\nSQL: ' + sql)
	}

	var results = {
		index: [],
		meta: {},
		mapPseudo: {}
	}

	var requireGames = F.RELATION_GAMES.indexOf(F.RESULT_RELATION[config.resultType]) !== -1

	if (requireGames) {
		results.games = []
		results.mapGames = {}
		results.mapIndex = {}
		results.mapNested = {}
	}

	var concatLen = this._concat.length
	if (concatLen) {
		results.concat = {}
	}

	// Hoist column key set + meta key list out of the per-row loop. Every
	// row has the same columns, so Object.keys(rawResult) is identical
	// across rows. Compute it once.
	var fromKey = this._from[1]
	var firstRow = rawResults.length ? rawResults[0] : null
	var allKeys = firstRow ? Object.keys(firstRow) : []
	var metaKeys = []
	for (var mki = 0; mki < allKeys.length; mki++) {
		var mkey = allKeys[mki]
		if (mkey !== 'g' && mkey !== fromKey) metaKeys.push(mkey)
	}
	for (var mji = 0; mji < metaKeys.length; mji++) {
		results.meta[metaKeys[mji]] = {}
	}

	var resultsMeta = results.meta
	var resultsIndex = results.index
	var resultsGames = results.games
	var resultsMapGames = results.mapGames
	var resultsMapIndex = results.mapIndex
	var resultsMapNested = results.mapNested
	var resultsMapPseudo = results.mapPseudo
	var resultsConcat = results.concat
	var concat = this._concat
	var rawLen = rawResults.length

	for (var ri = 0; ri < rawLen; ri++) {
		var rawResult = rawResults[ri]
		if (!rawResult) continue

		var hasOverload = (rawResult.overload !== undefined && rawResult.overload !== null)
		var ids
		if (hasOverload) {
			ids = String(rawResult.overload).replace(/"/g, '').replace(/\[/g, '').replace(/\]/g, '').split(',')
		}

		// Process concat fields
		if (concatLen) {
			for (var ci = 0; ci < concatLen; ci++) {
				var cn = concat[ci][1]
				if (!resultsConcat[cn]) resultsConcat[cn] = []
				var cv = rawResult['c_' + cn]
				if (cv) resultsConcat[cn] = resultsConcat[cn].concat(String(cv).split(','))
			}
		}

		var hasNest = (rawResult.nest !== undefined)
		var rawG = rawResult.g
		var rawPseudo = rawResult.pseudo
		var pseudoVal = (rawPseudo !== undefined) ? (rawPseudo | 0) : 1

		var idsLen = hasOverload ? ids.length : 1
		for (var ii = 0; ii < idsLen; ii++) {
			var id = hasOverload ? (ids[ii] | 0) : (rawResult[fromKey] | 0)

			if (hasNest) {
				resultsMapNested[rawG] = rawResult.nest ? rawResult.nest : rawG
			}

			// Store all meta fields. Use the precomputed metaKeys list
			// instead of Object.keys(rawResult) per row.
			for (var ki = 0; ki < metaKeys.length; ki++) {
				var key = metaKeys[ki]
				var existing = resultsMeta[key][id]
				var value = rawResult[key]
				if (existing !== undefined && existing !== value && Util.is_json_object(value)) {
					if (!Array.isArray(existing)) {
						resultsMeta[key][id] = [existing]
					}
					resultsMeta[key][id].push(value)
				} else {
					resultsMeta[key][id] = value
				}
			}

			if (requireGames) {
				var gid = rawG | 0
				if (!resultsMapGames[gid]) resultsMapGames[gid] = []
				resultsGames.push(gid)
				resultsMapIndex[id] = gid
				resultsMapGames[gid].push(id)
			}

			resultsIndex.push(id)
			resultsMapPseudo[id] = pseudoVal
		}
	}

	return results
}

Query.prototype.prepare = function(config, filter, data) {
	this.from(F.RESULT_TABLE[config.resultType], F.RESULT_RELATION[config.resultType])

	// Remove joins that match the from table
	var newJoin = []
	for (var i = 0; i < this._join.length; i++) {
		if (this._join[i][0] !== this._from[0]) newJoin.push(this._join[i])
	}
	this._join = newJoin

	var exclude = [this._from[1]]

	// Attach user_id filter if result is a user-scoped relation
	if (F.RELATION_USERS.indexOf(F.RESULT_RELATION[config.resultType]) !== -1) {
		if (data.users.length > 1) {
			this.where(F.RESULT_RELATION[config.resultType] + '.user_id', 'in', data.users)
		} else {
			this.where(F.RESULT_RELATION[config.resultType] + '.user_id', '=', data.users[0])
		}
	}

	// Analyse select/order fields to determine required joins
	var selectOrderRelations = this._analyseFields([this._select, this._order], exclude)
	for (var si = 0; si < selectOrderRelations.length; si++) {
		var relation = selectOrderRelations[si]

		if (relation === F.RELATION_VERSION) {
			// Check if v is already explicitly joined (e.g. by an advanced rule)
			var alreadyJoined = false
			for (var ji = 0; ji < this._join.length; ji++) {
				if (this._join[ji][1] === F.RELATION_VERSION) { alreadyJoined = true; break }
			}
			if (!alreadyJoined) {
				// Version join via collection requires game + collection first.
				// Priorities: game (9) → collection (10) → version (11)
				if (exclude.indexOf(F.RELATION_GAME) === -1) {
					this.join(F.RELATION_TABLE[F.RELATION_GAME], F.RELATION_GAME, 'JOIN', 'game_id', 9)
					exclude.push(F.RELATION_GAME)
				}
				if (exclude.indexOf(F.RELATION_COLLECTION) === -1) {
					this.where('c.user_id', '=', config.owner.get_id())
					this.join(F.RELATION_TABLE[F.RELATION_COLLECTION], F.RELATION_COLLECTION, 'JOIN', 'game_id', 10)
					exclude.push('c')
				}
				this.join(F.RELATION_TABLE[relation], relation, 'LEFT JOIN', 'game_version_id', 11)
			}
		} else {
			var primary = relation.charAt(0)

			if (F.RELATION_USERS.indexOf(primary) !== -1) {
				var attachUsers = data.users

				if (relation.length === 2) {
					var rtype = relation.charAt(1)
					if (rtype === 'g') {
						attachUsers = data.users
					} else if (rtype === 'u') {
						attachUsers = config.userID ? [config.userID] : false
					}
				}

				if (attachUsers) {
					if (attachUsers.length > 1) {
						this.where(relation + '.user_id', 'in', attachUsers)
					} else {
						this.where(relation + '.user_id', '=', attachUsers[0])
					}
				}
			}

			this.join(F.RELATION_TABLE[primary], relation)
		}

		exclude.push(relation)
	}

	// Analyse where/having fields to determine required EXISTS subqueries
	var whereRelations = this._analyseFields([this._having, this._where, this._whitelist], exclude)
	for (var wi = 0; wi < whereRelations.length; wi++) {
		var rel = whereRelations[wi]
		if (!this.existed(rel)) {
			this.exist(F.RELATION_TABLE[rel.charAt(0)], rel)
		}
		exclude.push(rel)
	}

	// Add game_id select if not game result but game relation needed
	if (config.resultType !== F.RESULT_GAME && F.RELATION_GAMES.indexOf(F.RESULT_RELATION[config.resultType]) !== -1) {
		this.select(this._from[1] + '.game_id', 'g')
	}

	// Add base relation select and group
	this.select(this._from[1] + '.' + this._from[0] + '_id', this._from[1])
	this.group(this._from[1] + '.' + this._from[0] + '_id')
}

Query.prototype.build = function(config, filter, data) {
	var sql = []

	// SELECT
	sql.push('SELECT')
	var sqlSelect = []

	for (var i = 0; i < this._select.length; i++) {
		sqlSelect.push(this._select[i][0] + ' as ' + this._select[i][1])
	}

	if (this._orderless) {
		for (var oi = 0; oi < this._order.length; oi++) {
			sqlSelect.push(this._order[oi][0] + ' AS order_' + sqlSelect.length + '_' + this._order[oi][1].toLowerCase() + '_' + this._order[oi][2])
		}
	}

	// GROUP_CONCAT - adapted for SQLite syntax
	for (var ci = 0; ci < this._concat.length; ci++) {
		sqlSelect.push('group_concat(DISTINCT ' + this._concat[ci][0] + ') as c_' + this._concat[ci][1])
	}

	sql.push(unique(sqlSelect).join(', '))

	// FROM
	sql.push('FROM')

	var joinExclude = []
	var joinIndex = []

	if (this._join.length) {
		// Sort joins by priority
		this._join = Util.sort_by_field(this._join, 4)

		sql.push('('.repeat(this._join.length - 1))
		sql.push(this._from[0])
		sql.push(this._from[1])

		var previousRelation = this._from[1]
		var count = 0

		for (var ji = 0; ji < this._join.length; ji++) {
			var join = this._join[ji]
			count++

			var joinRelation = previousRelation

			// Enforce game relation when joining non-game/collection tables by game_id
			if (join[3] === 'game_id' && previousRelation !== F.RELATION_GAME && previousRelation !== F.RELATION_COLLECTION && join[1] !== F.RELATION_GAME && join[1] !== F.RELATION_COLLECTION) {
				joinRelation = F.RELATION_GAME
			} else if (join[3] === 'game_version_id') {
				joinRelation = F.RELATION_COLLECTION
			}

			// Promote LEFT JOIN to JOIN if EXISTS or WHERE references this table
			if (
				join[2] === 'LEFT JOIN' &&
				[F.RELATION_VERSION].indexOf(join[1]) === -1 &&
				(this.existed(join[1]) || this.sourced(join[1]) || this._buildSqlWhere(join[1], [], true).length > 1) &&
				this._leftjoin_force.indexOf(join[1]) === -1
			) {
				join[2] = 'JOIN'
			}

			sql.push(join[2] + ' ' + join[0] + ' ' + join[1] + ' ON ' + joinRelation + '.' + join[3] + ' = ' + join[1] + '.' + join[3])

			if (join[2] === 'LEFT JOIN') {
				joinExclude.push(join[1])
				var joinWhere = this._buildSqlWhere(join[1], [], false, false)
				if (joinWhere) sql.push('AND ' + joinWhere)
			}

			joinIndex.push(join[1])

			if (count !== this._join.length) sql.push(')')

			previousRelation = (join[2] === 'LEFT JOIN') ? previousRelation : join[1]
		}
	} else {
		sql.push(this._from[0])
		sql.push(this._from[1])
		joinIndex.push(this._from[1])
	}

	var sqlWhere = []
	var sqlWhitelist = []

	var insertWhere = this._buildSqlWhere([], joinExclude, false, true)
	var insertWhitelist = this._buildSqlWhitelist([], joinExclude, false, true)

	if (insertWhere) sqlWhere.push(insertWhere)
	if (insertWhitelist) sqlWhitelist.push(insertWhitelist)

	var sqlSource = []
	var sqlExist = []

	// Source EXISTS
	for (var si = 0; si < this._source.length; si++) {
		var src = this._source[si]
		if (!this.existed(src[1]) && joinIndex.indexOf(src[1]) === -1 && this._from[1] !== src[1]) {
			if (src[1] !== 'c') {
				var srcCl = []
				srcCl.push('EXISTS')
				srcCl.push('(')
				srcCl.push('SELECT *')
				srcCl.push('FROM')
				srcCl.push(src[0])
				srcCl.push(src[1])
				srcCl.push('WHERE')
				srcCl.push('g.game_id')
				srcCl.push('=')
				srcCl.push(src[1] === 'x' ? src[1] + '.game_relation_child' : src[1] + '.game_id')

				if (F.RELATION_USERS.indexOf(src[1]) !== -1) {
					srcCl.push('AND')
					srcCl.push(src[1] + '.user_id')
					if (data.users.length > 1) {
						srcCl.push('in')
						srcCl.push('(' + data.users.join(',') + ')')
					} else {
						srcCl.push('=')
						srcCl.push(data.users[0])
					}
				}

				srcCl.push('GROUP BY')
				srcCl.push(src[1] === 'x' ? src[1] + '.game_relation_child' : src[1] + '.game_id')
				srcCl.push(')')

				sqlSource.push(srcCl.join(' '))
			}
		}
	}

	// EXISTS subqueries
	for (var ei = 0; ei < this._exist.length; ei++) {
		var ex = this._exist[ei]
		if (joinIndex.indexOf(ex[1]) === -1) {
			var exWhere = this._buildSqlWhere(ex[1], [], false, true)
			var exHaving = this._buildSqlHaving(ex[1], [], false, true)

			var exCl = []
			if (ex[2]) exCl.push('NOT')
			exCl.push('EXISTS')
			exCl.push('(')
			exCl.push('SELECT *')
			exCl.push('FROM')
			exCl.push(ex[0])
			exCl.push(ex[1])
			exCl.push('WHERE')
			exCl.push('g.game_id')
			exCl.push('=')
			exCl.push(ex[1] === 'x' ? ex[1] + '.game_relation_child' : ex[1] + '.game_id')

			if (exWhere) {
				exCl.push('AND')
				exCl.push(exWhere)
			}

			// Add user_id constraint if not already in where
			if ((!exWhere || exWhere.indexOf(ex[1] + '.user_id') === -1) && F.RELATION_USERS.indexOf(ex[1]) !== -1) {
				exCl.push('AND')
				exCl.push(ex[1] + '.user_id')
				if (data.users.length > 1) {
					exCl.push('in')
					exCl.push('(' + data.users.join(',') + ')')
				} else {
					exCl.push('=')
					exCl.push(data.users[0])
				}
			}

			exCl.push('GROUP BY')
			exCl.push(ex[1] === 'x' ? ex[1] + '.game_relation_child' : ex[1] + '.game_id')

			if (exHaving) {
				exCl.push('HAVING')
				exCl.push(exHaving)
			}

			exCl.push(')')
			sqlExist.push(exCl.join(' '))
		}
	}

	if (sqlWhitelist.length || sqlWhere.length || sqlExist.length || sqlSource.length) {
		sql.push('WHERE')
	}

	if (sqlWhitelist.length) sql.push('(')

	if (sqlSource.length) {
		sql.push('(')
		sql.push(sqlSource.join(' OR '))
		sql.push(')')
		if (sqlExist.length || sqlWhere.length) sql.push('AND')
	}

	if (sqlExist.length) {
		sql.push(sqlExist.join(' AND '))
		if (sqlWhere.length) sql.push('AND')
	}

	if (sqlWhere.length) {
		for (var ww = 0; ww < sqlWhere.length; ww++) sql.push(sqlWhere[ww])
	}

	if (sqlWhitelist.length) {
		sql.push(')')
		sql.push('OR')
		sql.push('(')
		for (var wl = 0; wl < sqlWhitelist.length; wl++) sql.push(sqlWhitelist[wl])
		sql.push(')')
	}

	// GROUP BY
	if (this._group.length) {
		sql.push('GROUP BY')
		sql.push(unique(this._group).join(', '))
	}

	// HAVING
	var sqlHaving = this._buildSqlHaving([], [], false, true)
	if (sqlHaving) {
		sql.push('HAVING')
		sql.push(sqlHaving)
	}

	// ORDER BY
	this._order = Util.sort_by_field(this._order, 2, true)

	if (!this._orderless) {
		if (this._order.length) sql.push('ORDER BY')
		var sqlOrder = []
		for (var ord = 0; ord < this._order.length; ord++) {
			sqlOrder.push(this._order[ord][0] + ' ' + this._order[ord][1])
		}
		sql.push(unique(sqlOrder).join(', '))
	}

	var result = sql.join(' ')

	// Fix edge cases (same as PHP)
	result = result.replace(/\( \) OR/g, '')
	result = result.replace(/\( game g JOIN game g ON g\.game_id = g\.game_id \)/g, 'game g')
	result = result.replace(/LEFT JOIN custom_rename y ON g\.game_id = y\.game_id AND/g, 'LEFT JOIN custom_rename y ON c.collection_id = y.collection_id AND')

	return result
}

// Internal: build SQL condition string from a source array
Query.prototype._buildConditions = function(relations, exclude, source, asArray, allowSticky) {
	if (!Array.isArray(relations)) relations = relations ? [relations] : []
	if (!Array.isArray(exclude)) exclude = exclude ? [exclude] : []

	if (!relations.length) {
		relations.push(this._from[1])
		for (var i = 0; i < this._join.length; i++) {
			relations.push(this._join[i][1])
		}
	}

	relations = relations.filter(function(r) { return exclude.indexOf(r) === -1 })
	if (!relations.length) return asArray ? [] : false

	var sqlWhere = []
	var relPattern = new RegExp('((\\(|^)(' + relations.join('|') + ')\\.)')

	function emitAtomic(triplet) {
		var field = triplet[0], op = triplet[1], val = triplet[2]

		var isSticky = false
		if (/^\*\s*/.test(field)) {
			isSticky = true
			field = field.replace(/^\*\s*/, '')
		}

		if (isSticky && allowSticky) {
			return whereBuilder(field, val, op)
		}

		if (relPattern.test(field)) {
			return whereBuilder(field, val, op)
		}

		return null
	}

	for (var wi = 0; wi < source.length; wi++) {
		var w = source[wi]

		if (w.length === 3 && !Array.isArray(w[1])) {
			// Atomic: [field, op, value]
			var built = emitAtomic(w)
			if (built) sqlWhere.push(built)
		} else {
			// Group: [andOr, [subclauses...]]
			var andOr = w[0]
			var sqlGroup = []

			for (var gi = 0; gi < w[1].length; gi++) {
				var sub = w[1][gi]
				if (sub.length === 3 && !Array.isArray(sub[1])) {
					var b = emitAtomic(sub)
					if (b) sqlGroup.push(b)
				} else if (sub.length === 2 && Array.isArray(sub[1])) {
					// Nested group
					var nestedAndOr = sub[0]
					var sqlSubGroup = []
					for (var si = 0; si < sub[1].length; si++) {
						if (sub[1][si].length === 3) {
							var sb = emitAtomic(sub[1][si])
							if (sb) sqlSubGroup.push(sb)
						}
					}
					if (sqlSubGroup.length) {
						sqlGroup.push('(' + unique(sqlSubGroup).join(' ' + nestedAndOr + ' ') + ')')
					}
				}
			}

			if (sqlGroup.length) {
				sqlWhere.push('(' + unique(sqlGroup).join(' ' + andOr + ' ') + ')')
			}
		}
	}

	if (asArray) return sqlWhere
	return sqlWhere.length ? unique(sqlWhere).join(' AND ') : false
}

Query.prototype._buildSqlWhere = function(relations, exclude, asArray, allowSticky) {
	return this._buildConditions(relations, exclude, this._where, asArray || false, allowSticky || false)
}

Query.prototype._buildSqlWhitelist = function(relations, exclude, asArray, allowSticky) {
	return this._buildConditions(relations, exclude, this._whitelist, asArray || false, allowSticky || false)
}

Query.prototype._buildSqlHaving = function(relations, exclude, asArray, allowSticky) {
	return this._buildConditions(relations, exclude, this._having, asArray || false, allowSticky || false)
}

// Analyse field references to determine which table relations are needed
Query.prototype._analyseFields = function(queryKeywords, exclude) {
	var relations = []
	var relationKeys = Object.keys(F.RELATION_TABLE).join('')

	for (var ki = 0; ki < queryKeywords.length; ki++) {
		var keyword = queryKeywords[ki]
		for (var fi = 0; fi < keyword.length; fi++) {
			var field = keyword[fi]

			if (field.length === 3 || !Array.isArray(field[1])) {
				var pattern = new RegExp('[' + relationKeys + ']([a-z])?\\.', 'g')
				var matches
				while ((matches = pattern.exec(field[0])) !== null) {
					var rel = matches[0].charAt(0)
					if (matches[1]) rel += matches[1]
					if (exclude.indexOf(rel) === -1) relations.push(rel)
				}
			} else if (field.length === 2 && Array.isArray(field[1])) {
				var nested = this._analyseFields([field[1]], exclude)
				relations = relations.concat(nested)
			}
		}
	}

	return unique(relations)
}

Query.prototype._checkRename = function(data) {
	if (!Object.keys(this._rename).length) return data

	if (Array.isArray(data)) {
		for (var i = 0; i < data.length; i++) {
			data[i] = this._checkRename(data[i])
		}
	} else if (typeof data === 'string') {
		data = this._checkRenameItem(data)
	}

	return data
}

Query.prototype._checkRenameItem = function(data) {
	var keys = Object.keys(this._rename)
	for (var i = 0; i < keys.length; i++) {
		var key = keys[i]
		var val = this._rename[key]
		data = data.replace(new RegExp('((\\(|^)(' + key + ')\\.)', 'g'), val + '.')
		data = data.replace(new RegExp('^' + key + '$'), val)
	}
	return data
}

function unique(arr) {
	var seen = {}
	return arr.filter(function(item) {
		if (seen[item]) return false
		seen[item] = true
		return true
	})
}

export default Query
